'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var tools = require('./tools'),
    ids = require('./ids'),
    links = require('./links');


module.exports = function ( data ) {
    var gettext = links.gettext,
        renders = links.api.renders,
        lanList, pppoeList, wifiList,
        result, gateways, servers,
        title, ip;

    result = JSON.parse(gSTB.GetEnv(JSON.stringify({
        varList: ['lan_noip', 'ipaddr_conf', 'dnsip', 'pppoe_enabled', 'pppoe_login', 'pppoe_dns1', 'wifi_ssid', 'wifi_int_ip']
    }))).result;

    gateways = gSTB.GetNetworkGateways();
    servers = gSTB.GetNetworkNameServers();

    if ( result.lan_noip === 'true' ) {
        title = gettext('No config');
    } else {
        title = gettext('DHCP');
        if ( tools.checkIP(result.ipaddr_conf) ) {
            title += ' - (' + gettext('Static IP') + ')';

        } else if ( tools.checkIP(result.dnsip) ) {
            title += ' - (' + gettext('Manual DNS') + ')';
        }
    }

    lanList = [
        {
            label: title,
            value: ''
        },
        {
            label: gettext('Link status:'),
            value: gSTB.GetLanLinkStatus() ? 'UP' : 'DOWN'
        },
        {
            label: gettext('Mask:'),
            value: gSTB.RDir('IPMask')
        },
        {
            label: gettext('MAC:'),
            value: gSTB.GetDeviceMacAddress()
        },
        {
            label: gettext('IP:'),
            value: gSTB.RDir('IPAddress')
        },
        {
            label: gettext('Gateway:'),
            value: gateways === '' ? 'n/a' : gateways.replace(/\r\n|\r|\n/g, ', ')
        },
        {
            label: gettext('DNS server:'),
            value: servers === '' ? 'n/a' : servers.replace(/\r\n|\r|\n/g, ', ')
        }
    ];

    title = '';
    if ( result.pppoe_enabled === 'true' ) {
        title = 'PPPoE - ' + result.pppoe_login;
    } else {
        title = gettext('PPPoE - Disabled');
    }
    ip = gSTB.GetPppoeIp();
    gateways = gSTB.GetNetworkGateways();
    servers = gSTB.GetNetworkNameServers();

    pppoeList = [
        {
            label: title,
            value: ''
        },
        {
            label: gettext('Link status:'),
            value: gSTB.GetPppoeLinkStatus() ? 'UP' : 'DOWN'
        },
        {
            label: gettext('IP:'),
            value: ip === '' ? 'n/a' : ip
        },
        {
            label: gettext('Gateway:'),
            value: gateways === '' ? 'n/a' : gateways.replace(/\r\n|\r|\n/g, ', ')
        },
        {
            label: gettext('DNS server:'),
            value: servers === '' ? 'n/a' : servers.replace(/\r\n|\r|\n/g, ', ')
        }
    ];

    title = '';
    gateways = gSTB.GetNetworkGateways();
    servers = gSTB.GetNetworkNameServers();
    if ( result.wifi_ssid ) {
        title = '"' + result.wifi_ssid + '" ( ';
        if ( tools.checkIP(result.wifi_int_ip) ) {
            title += gettext('Static IP') + ')';
        } else {
            title += 'DHCP)';
        }
    } else {
        title = gettext('Wi-Fi - "Disabled"');
    }

    ip = gSTB.RDir('WiFi_ip');

    wifiList = [
        {
            label: title,
            value: ''
        },
        {
            label: gettext('Link status:'),
            value: gSTB.GetWifiLinkStatus() ? 'UP' : 'DOWN'
        },
        {
            label: gettext('IP:'),
            value: ip === '' ? 'n/a' : ip
        },
        {
            label: gettext('MAC:'),
            value: gSTB.GetNetworkWifiMac()
        },
        {
            label: gettext('Gateway:'),
            value: gateways === '' ? 'n/a' : gateways.replace(/\r\n|\r|\n/g, ', ')
        },
        {
            label: gettext('DNS server:'),
            value: servers === '' ? 'n/a' : servers.replace(/\r\n|\r|\n/g, ', ')
        }
    ];

    data.sections.push({
        id: ids.info,
        name: gettext('Network info'),
        description: gettext('Network info description'),
        icon: '',
        parent: ids.base
    });

    data.options.push({
        id: ids.infoLan,
        icon: '',
        name: gettext('DHCP'),
        description: lanList,
        render: renders.listItem,
        saveImmediate: true,
        parent: ids.info
    });

    switch ( core.device.model ) {
        case 'MAG324':
        case 'MAG325':
        case 'MAG349':
        case 'MAG350':
        case 'MAG351':
        case 'MAG352':
        case 'MAG256':
        case 'MAG257':
            break;
        case 'emulator':
        case 'emulator_stb':
        case 'AndroidSTB':
        case 'AndroidAPP':
            break;
        default:
            data.options.push({
                id: ids.infoPPPOE,
                icon: '',
                name: gettext('PPPoE'),
                description: pppoeList,
                render: renders.listItem,
                saveImmediate: true,
                parent: ids.info
            });
            break;
    }


    data.options.push({
        id: ids.infoWifi,
        icon: '',
        name: gettext('Wi-Fi'),
        description: wifiList,
        render: renders.listItem,
        saveImmediate: true,
        parent: ids.info
    });
};
